import Menu from './menu';

export default { Menu };
